import React, { lazy, Suspense } from "react";
import { FaCheck } from "react-icons/fa6";

const Whywaggexcommonchoice = lazy(
  () => import("./common/Whywaggexcommonchoice"),
);

const LookingforPayroll = lazy(() => import("./common/LookingforPayroll"));
const HomeFaq = lazy(() => import("../../pages/HomeFaq"));

const AppDownloadCard = lazy(() => import("../common/AppDownloadCard"));

const PayrollBanner = lazy(() => import("../common/PayrollBanner"));

const ModernizeHR = lazy(() => import("../common/ModernizeHR"));

import mobile364 from "@/assets/citywise/waggex-payroll-software-bangalore-hero-dashboard.webp";
import mobile556 from "@/assets/citywise/waggex-payroll-software-bangalore-hero-dashboard.webp";
import { Helmet } from "react-helmet-async";

const Bangalore = () => {
  const faq1 = [
    {
      title: "Is Waggex suitable for small and growing businesses?",
      content:
        "Yes. Waggex is designed for startups, SMEs, and growing businesses that want to automate payroll, attendance, leave management, and employee records without investing in complex HR systems.",
    },
    {
      title: "Does Waggex support attendance-based payroll calculation?",
      content:
        "Yes. Waggex automatically calculates salaries based on attendance, shifts, leaves, overtime, and working hours, helping businesses reduce manual payroll work and improve accuracy.",
    },
    {
      title: "Can employees mark attendance using their mobile phones?",
      content:
        "Yes. Employees can mark attendance through the Waggex mobile app using GPS location tracking, selfie attendance, geo-fencing, or FaceLens AI face recognition, depending on company policies.",
    },
  ];

  const faq2 = [
    {
      title: "Does Waggex provide AI face recognition attendance?",
      content:
        "Yes. Waggex FaceLens uses AI-powered face recognition technology to verify employee identity during check-in and check-out, helping prevent buddy punching and fake attendance.",
    },
    {
      title: "Can employees access payslips and leave details themselves?",
      content:
        "Yes. The Waggex Staff App allows employees to view attendance records, download payslips, apply for leave, check leave balances, and receive important company notifications without contacting HR.",
    },
  ];
  const schema = [
    {
      "@context": "https://schema.org",
      "@type": "Service",

      name: "Waggex Payroll Software Bangalore",
      serviceType: "Payroll Management Software",

      url: "https://www.waggex.com/best-payroll-software-in-bangalore",

      description:
        "Waggex is payroll and HRMS software for Bangalore businesses, automating payroll processing, attendance tracking, leave management, employee records, and workforce management.",

      image: "https://www.waggex.com/waggex-payroll-software-logo.png",

      areaServed: {
        "@type": "City",
        name: "Bangalore",
      },

      provider: {
        "@type": "Organization",
        name: "Waggex",
        url: "https://www.waggex.com/",
        logo: "https://www.waggex.com/waggex-payroll-software-logo.png",
      },

      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "INR",
        availability: "https://schema.org/InStock",
      },

      featureList: [
        "Payroll software Bangalore",
        "Attendance management software Bangalore",
        "Leave and shift management Bangalore",
        "Face recognition attendance Bangalore",
        "Employee self-service app",
      ],
    },

    {
      "@context": "https://schema.org",
      "@type": "FAQPage",

      mainEntity: [
        {
          "@type": "Question",
          name: "Which is the best payroll software in Bangalore?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "The best payroll software depends on your business requirements. Waggex helps businesses automate payroll, attendance management, leave tracking, and payslip generation from one platform.",
          },
        },
        {
          "@type": "Question",
          name: "Does Waggex support attendance-based payroll?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Waggex links employee attendance, approved leave, and working hours directly to payroll, ensuring accurate salary calculations.",
          },
        },
        {
          "@type": "Question",
          name: "Does Waggex provide mobile attendance?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Employees can mark attendance using selfie-based or GPS-based check-ins through the Waggex Staff App.",
          },
        },
        {
          "@type": "Question",
          name: "Does Waggex support face recognition attendance?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Waggex provides AI-powered face recognition attendance for secure employee verification and prevention of proxy attendance.",
          },
        },
        {
          "@type": "Question",
          name: "Is Waggex suitable for startups and SMEs in Bangalore?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Waggex is designed for startups, SMEs, and growing businesses looking for affordable payroll and HR software.",
          },
        },
      ],
    },

    {
      "@context": "https://schema.org",
      "@type": "Organization",

      name: "Waggex",
      url: "https://www.waggex.com/",

      logo: "https://www.waggex.com/waggex-payroll-software-logo.png",

      description:
        "Waggex provides payroll, attendance, leave management, HRMS, and workforce management software for businesses across India.",

      areaServed: {
        "@type": "Country",
        name: "India",
      },

      contactPoint: {
        "@type": "ContactPoint",
        contactType: "customer support",
        availableLanguage: ["English", "Hindi"],
      },

      sameAs: ["https://www.linkedin.com/company/waggex"],
    },

    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",

      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.waggex.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Best Payroll Software in Bangalore",
          item: "https://www.waggex.com/best-payroll-software-in-bangalore",
        },
      ],
    },
  ];

  return (
    <>
      <Helmet>
        <title>Payroll Software in Bangalore For Business & Startups</title>
        <meta
          name="description"
          content="Find the best payroll software in Bangalore for businesses and startups. Streamline salary processing, tax compliance, attendance, and HR tasks"
        />
        <meta
          name="keywords"
          content="payroll software in Bangalore,payroll software Bangalore,HR software for businesses in Bangalore,attendance management software Bangalore,HRMS software Bangalore,online payroll system Bangalore,employee management software Bangalore,leave management software Bangalore,face recognition attendance Bangalore,payroll software for IT companies Bangalore
"
        />
        <link
          rel="canonical"
          href="https://www.waggex.com/best-payroll-software-in-bangalore"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schema),
          }}
        />
      </Helmet>
      <section className="w-full bg-[#d1dfea] overflow-hidden py-10 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-10 mb-20 mt-10">
            {/* Left Content */}
            <div className="text-center lg:text-left">
              {/* Heading */}
              <h1 className="mt-6 text-[#10324F] font-bold uppercase tracking-wide text-xl md:text-[28px] min-h-16">
                Best Payroll Software in Bangalore for Businesses
              </h1>

              {/* Description */}
              <p className="service-list-item-text py-4 max-w-xl">
                <strong> Waggex</strong> helps Bangalore businesses automate
                payroll, attendance, leave management, and employee records from
                one centralized platform. Built for startups, SMEs, IT
                companies, and growing organizations, it simplifies daily HR
                operations while improving accuracy, compliance, and workforce
                productivity
              </p>

              {/* Buttons */}
              <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <button
                  onClick={() =>
                    (window.location.href = "https://app.waggex.com/signup")
                  }
                  className="w-full sm:w-auto bg-[#10324F] hover:bg-[#10324F] transition-all duration-300 text-white px-14 py-3 rounded-xl shadow-md text-sm sm:text-base font-medium"
                >
                  Start Free Trial
                </button>

                <button
                  onClick={() => (window.location.href = "/contact-us")}
                  className="w-full sm:w-auto border border-[#10324F] text-[#10324F] hover:bg-[#10324F] hover:text-white transition-all duration-300 px-14 py-3 rounded-xl text-sm sm:text-base font-medium"
                >
                  Book a Demo
                </button>
              </div>
            </div>

            {/* Right Image */}
            <div className="relative flex justify-center items-center">
              {/* Phones Image */}
              <picture>
                <source media="(max-width: 639px)" srcSet={mobile364} />

                <img
                  src={mobile556}
                  fetchPriority="high"
                  width={556}
                  height={430}
                  loading="eager"
                  decoding="async"
                  alt="Waggex all-in-one payroll software Bangalore showing payroll automation, attendance management, employee management and compliance support"
                  className="relative object-contain "
                />
              </picture>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#FFFFFF] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Trusted Payroll & HR Software for Growing Bangalore Businesses
            </h2>
            <p className="mt-4 text-[#10324F] text-sm sm:text-base leading-relaxed">
              From startups and IT companies to retail stores and service
              businesses, Waggex helps Bangalore organizations automate payroll,
              attendance, leave management, and employee operations while
              reducing manual HR work and improving workforce visibility
            </p>
          </div>
          {/* List */}
          <div className="mt-10 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Automated Payroll Processing</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Shift Management</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Attendance-Based Salary Calculation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>PDF Payslip Generation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>AI Selfie Attendance</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee Self-Service App</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>GPS Attendance Tracking</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Real-Time Notifications</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee Leave Management</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Face Recognition Attendance</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-[#F3F5F7] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Smart Payroll Software Built for Bangalore Businesses
            </h2>
            <p className="mt-4 text-[#10324F] text-sm sm:text-base">
              Payroll processing requires accurate salary calculations,
              attendance integration, overtime tracking, and proper employee
              records. Waggex automates payroll operations so finance and HR
              teams spend less time on manual calculations
            </p>
          </div>
          {/* List */}
          <div className="mt-10 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Automated payroll calculation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee salary reports</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Attendance-based payroll processing</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Payroll history and records</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Overtime and shift salary management</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee payroll notifications</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Payslip generation in PDF format</span>
              </div>
            </div>
          </div>
          <p className="mt-8 text-[#10324F] text-sm sm:text-base text-center max-w-3xl mx-auto leading-loose">
            Save hours of manual payroll work with automated salary processing,
            instant payslip generation, and employee self-service access through
            the <strong>Waggex Staff App</strong>
          </p>
        </div>
      </section>
      <section className="bg-[#FFFFFF] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Complete Attendance Control for Modern Teams
            </h2>
            <p className="mt-4 text-[#10324F] text-sm sm:text-base">
              Managing attendance for remote teams, field employees, hybrid
              staff, and multiple office locations can be difficult. Waggex
              helps businesses eliminate buddy punching, manual attendance
              errors, and location fraud while giving HR teams complete
              visibility into workforce attendance
            </p>
          </div>
          {/* List */}
          <div className="mt-8 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>AI Selfie Attendance</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Shift-Based Attendance</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>GPS Attendance Tracking</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Mobile Attendance Marking</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Geofencing</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Real-Time Attendance Reports</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>FaceLens AI Face Recognition Attendance</span>
              </div>
            </div>
          </div>{" "}
          <p className="mt-8 text-[#10324F] text-sm sm:text-base text-center max-w-5xl mx-auto">
            Reduce attendance disputes, improve payroll accuracy, and gain
            real-time workforce visibility with a centralized attendance
            management platform built for growing businesses
          </p>
        </div>
      </section>
      <section className="bg-[#F3F5F7] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Simplify Leave Tracking & Shift Scheduling
            </h2>

            <p className="mt-4 text-[#10324F] text-sm sm:text-base">
              Managing employee leave requests, shift rotations, weekly offs,
              and attendance adjustments manually can create confusion and
              scheduling gaps. We help businesses streamline leave approvals and
              workforce scheduling from a single platform
            </p>
          </div>

          {/* List */}
          <div className="mt-8 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Yearly leave allocation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Leave approval workflow</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Leave balance tracking</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Real-time leave notifications</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Attendance-based leave management</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Shift management</span>
              </div>
            </div>{" "}
          </div>
          <p className="mt-8 text-[#10324F] text-sm sm:text-base text-center max-w-2xl mx-auto leading-loose">
            Reduce scheduling conflicts, improve workforce availability, and
            give employees a transparent leave management experience while
            saving HR teams valuable administrative time
          </p>
        </div>
      </section>
      <section className="bg-[#FFFFFF] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Everything Employees Need in One Mobile App
            </h2>
            <p className="mt-4 text-[#10324F] text-sm sm:text-base max-w-5xl mx-auto">
              Employees can manage attendance, leave, payslips, and HR requests
              independently, helping businesses reduce administrative work and
              improve operational efficiency
            </p>
            <p className="mt-4 text-[#10324F] text-lg">Employee Can:</p>
          </div>
          {/* List */}
          <div className="mt-8 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Mark attendance</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>View attendance history</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Apply for leave </span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Receive notifications</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Download payslips</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Access employee records</span>
              </div>
            </div>
          </div>{" "}
          <p className="mt-8 text-[#10324F] text-sm sm:text-base text-center">
            Empower employees with self-service access while reducing repetitive
            HR queries, paperwork, and administrative workload across your
            organization
          </p>
        </div>
      </section>
      <section className="bg-[#F3F5F7] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Built for Businesses of Every Size and Industry
            </h2>

            <p className="mt-4 text-[#10324F] text-lg">
              Waggex is suitable for:
            </p>
          </div>

          {/* List */}
          <div className="mt-10 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Startups</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Factories</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>SMEs</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Service Companies</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>IT Companies</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Field Workforce Businesses</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Retail Businesses</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Agencies & Consultancies</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Suspense fallback={null}>
        <Whywaggexcommonchoice
          heading="Why Bangalore Businesses Choose Waggex?"
          description="Businesses in India often spend too much time managing attendance, leaves, payroll calculations, and employee records manually. As teams grow, keeping workforce data accurate and organized becomes more difficult and we help you streamline that"
          paragraph=""
        />
        <LookingforPayroll
          heading="Ready to Simplify Payroll & HR Management?"
          subHeading="Book a Free Demo and See Waggex in Action"
          description="Manage payroll, attendance, leave, shifts, and employee operations using one growing platform built for Bangalore HR teams"
          features={[
            "AI Attendance Management",
            "Payroll Automation",
            "Employee Self-Service App",
            "GPS & Face Recognition Attendance",
            "Attendance-Based Payroll",
            "Real-Time Notifications",
          ]}
          buttonText="Book Free Demo"
        />
        <HomeFaq
          faq1={faq1}
          faq2={faq2}
          subtitle="Everything you need to know about Waggex payroll software in India"
        />
        {/*  <AppDownloadCard /> */}
        <PayrollBanner
          heading="Stop Wasting Hours on Payroll Every Month"
          description="Automate payroll calculations, attendance tracking, leave deductions, and payslip generation with one centralized platform built for growing businesses"
          buttonText="View HRMS Software"
          buttonLink="https://waggex.com/"
        />
        <AppDownloadCard />
        <ModernizeHR />
      </Suspense>
    </>
  );
};

export default Bangalore;
